const {
  REACT_APP_GITHUB_CLIENT_ID: GITHUB_CLIENT_ID,
  REACT_APP_GITLAB_CLIENT_ID: GITLAB_CLIENT_ID,
  REACT_APP_GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID,
  REACT_APP_JIRA_CLIENT_ID: JIRA_CLIENT_ID,
  REACT_APP_STRIPE_CLIENT_ID: STRIPE_CLIENT_ID,
  REACT_APP_REDIRECT_URI: REDIRECT_URI,
} = process.env

const jiraScopes = [
  'application-role',
  'audit-log',
  'avatar',
  'comment', 'comment.property',
  'dashboard', 'dashboard.property',
  'field', 'field.option', 'field-configuration',
  'filter', 'filter.column',
  'group',
  'issue', 'issue.time-tracking', 'issue.transition',
  'issue-details', 'issue-event', 'issue-meta',
  'issue-status', 'issue-type', 'issue-type-hierarchy',
  'label',
  'permission',
  'priority',
  'project', 'project.component', 'project.property',
  'project-category', 'project-version',
  'resolution',
  'status',
  'user'
]

export const googleAuthURL = 'https://accounts.google.com'
  + '/o/oauth2/v2/auth?access_type=offline'
  + '&prompt=consent'
  + '&scope=https://www.googleapis.com/auth/analytics.readonly'
  + '&response_type=code'
  + `&client_id=${GOOGLE_CLIENT_ID}`
  + `&redirect_uri=${REDIRECT_URI}?service=google`

export const githubAuthURL = 'https://github.com'
  + '/login/oauth/authorize?'
  + 'scope=repo,read:org,read:user'
  + '&login=true'
  + `&client_id=${GITHUB_CLIENT_ID}`
  + `&redirect_uri=${REDIRECT_URI}?service=github`

export const gitlabAuthURL = 'https://gitlab.com'
  + '/oauth?response_type_type=code'
  + '&scope=???'
  + `&client_id=${GITLAB_CLIENT_ID}`
  + `&redirect_uri=${REDIRECT_URI}?service=gitlab`

export const jiraAuthURL = 'https://auth.atlassian.com'
  + '/authorize?audience=api.atlassian.com'
  + `&client_id=${JIRA_CLIENT_ID}`
  + '&prompt=consent'
  + '&scope=offline_access ' + jiraScopes.map(s => `read:${s}:jira`).join(' ')
  + '&response_type=code'
  + `&redirect_uri=${REDIRECT_URI}?service=jira`

export const stripeAuthURL = 'https://connect.stripe.com'
  + '/oauth/authorize?response_type=code'
  + '&scope=read_write'
  + `&client_id=${STRIPE_CLIENT_ID}`
  + `&redirect_uri=${REDIRECT_URI}?service=stripe`